import React, { useState } from "react";
import Navbar from "../global/Navbar";
import { useParams } from "react-router-dom";
import Thought from "../components/Test/Thought";
import Willness from "../components/Test/Willness";
import Knowledge from "../components/Test/Knowledge";
import Mind from "../components/Test/Mind";

const Test = () => {
  const { name } = useParams();
  const decodedCourseName = decodeURIComponent(name);
  const [active,setActive] = useState(decodedCourseName);

   const render = () => {
    switch (active) {
      case "thought":
        return <Thought/>;
      case "willness":
        return <Willness/>;
      case "learning":
        return <Knowledge/>;
      case "mind":
        return <Mind/>;
      default:
        return <h1>Default View</h1>;
    }
  };
  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#101e2b]">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0 mb-[5rem]">
        <div className="mt-[2rem] flex items-center justify-center gap-4 border-b border-[#22BEFF33]">
            <button className={`font-bold text-base cursor-pointer pb-2 ${active === "thought" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}`} onClick={()=>setActive('thought')}>THOUGHT TEST</button>
            <button className={`font-bold text-base cursor-pointer pb-2 ${active === "mind" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}`} onClick={()=>setActive('mind')}>MIND MAPPING TEST</button>
            
            <button className={`font-bold text-base cursor-pointer pb-2 uppercase ${active === "willness" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}`} onClick={()=>setActive('willness')}>Physical Wellness TEST</button>

        </div>
        <div className="mt-[2rem]">
          {render()}
        </div>
      </div>
    </div>
  );
};

export default Test;
